/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa6";
import { db } from "../../config/firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import CountrySelectInput from "../shared/countrySelectInput";
import { generatePDF } from "../shared/pdf/generatePDF";
import SideBar from "../sidebar/SideBar";
import Header from "../header/Header";
import { useParams } from "react-router-dom";
import { AmountFormat } from "../../lib/helper/amountFormat";
import { useNavigate } from "react-router-dom";
import CIFValue from "./helperComponent/CIFValue";
import ValidityDate from "./helperComponent/validityDate";
import ServiceTemp from "./servicesTemp/tempAdminEstimate"; // Changed import
import InsuranceCheckbox from "./helperComponent/insuranceCheckBox";
import TransportationMode from "./TransportationMode";
import CurrencyComponent from "./CurrencyComponent";
import CustomButton from "../shared/common/customButton";
import PDFDownloadButton from "../shared/pdf/pdfDownloadBtn";
import DashboardLayout from "../layout";
import { Select } from "antd";
import { useQueryClient } from "@tanstack/react-query";
import { useMyContext } from "../../context/MyContext";
import DiscountInput from "./helperComponent/DiscountInput";
const EditQuotesForm = () => {
  const obj = {
    ative: true,
    content: "Quote List",
  };

  const { id } = useParams();
  const [Total, setTotal] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const navigate = useNavigate();
  const [pdfLoading, setPdfLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [templateSelected, setTemplateSelected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [attemptedSubmit, setAttemptedSubmit] = useState(false);
  const { user } = useMyContext();
  const queryClient = useQueryClient();

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [quotationCreatedByAdmin, setQuotationCreatedByAdmin] = useState(true); // Set to true for edit form
  const [discountType, setDiscountType] = useState("percentage");
  const [discountValue, setDiscountValue] = useState("");

  const getDefaultValidityDate = () => {
    const creationDate = new Date();
    creationDate.setDate(creationDate.getDate() + 10);
    return creationDate.toISOString().split("T")[0]; // Get the date part only
  };
  const [formData, setFormData] = useState({
    status: "pending",
    validityDate: getDefaultValidityDate() || "",

    quoteNumber: "",
    quoteCreatedDate: "",
    companyName: "",
    name: "", // Use default value if customerData is null
    email: "",
    postalCode: "",
    address: "",
    // country: "",
    loadAddress: "",
    loadCountry: "",
    loadCity: "",
    loadPostalCode: "",
    loadAddress_CompanyName: "",
    unloadAddress: "",
    unloadCountry: "",
    unloadCity: "",
    unloadPostalCode: "",
    unloadAddress_CompanyName: "",
    modeOfTransfer: "",
    cargoValue: { value: "", currency: "USD" },
    cifValue: { value: "", currency: "USD" },
    pcsPackage: [
      {
        quantity: "",
        weight: { value: "", unit: "Kg" },
        length: { value: "", unit: "cm" },
        width: { value: "", unit: "cm" },
        height: { value: "", unit: "cm" },
      },
    ],
    totalWeight: totalWeight,
    description: "",
    services: [
      {
        numberOfItem: "",
        description: "",
        exclVAT: "",
      },
    ],
    total: Total,
    subTotal: 0,
    vatPercentage: 0,
    vatAmount: 0,
    currency: "USD",
    insurance: 0,
    // Add selectedTemplate field for tempAdminEstimate compatibility
    selectedTemplate: "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const userDocRef = doc(db, "quotes", id);
        const userDocSnap = await getDoc(userDocRef);

        if (userDocSnap.exists()) {
          const data = userDocSnap.data();
          setFormData(data);

          // Restore discount from saved quote if present
          const existingDiscount = data.discount || data.tradeOSData?.discount;
          if (existingDiscount) {
            setDiscountType(existingDiscount.type || "percentage");
            setDiscountValue(existingDiscount.value !== undefined ? existingDiscount.value : "");
          }

          // Set templateSelected based on selectedTemplate field
          if (data.selectedTemplate) {
            setTemplateSelected(true);
          }
        } else {
          toast.error("Quote data not found");
        }
      } catch (error) {
        console.error("Error fetching Quote data:", error);
      }
    };

    fetchData();
  }, [id]);

  useEffect(() => {
    // Calculate Sub Total and separate discountable base services
    let subTotal = 0;
    let discountableSubTotal = 0;

    formData.services.forEach((service) => {
      const totalForService =
        parseFloat(service.numberOfItem || 1) *
        parseFloat(service.exclVAT || 0);
      subTotal += totalForService;

      const desc = (service.description || "").trim().toLowerCase();
      const isTaxOrDuty =
        desc === "vat" ||
        desc.includes("duty") ||
        desc.includes("duties") ||
        desc.includes("tax");

      if (!isTaxOrDuty) {
        discountableSubTotal += totalForService;
      }
    });

    // Calculate Discount — applies only to base services subtotal, excluding VAT/Duties/Taxes
    const rawDiscount = parseFloat(discountValue) || 0;
    let discountAmount = 0;
    if (rawDiscount > 0) {
      if (discountType === "percentage") {
        discountAmount = (discountableSubTotal * rawDiscount) / 100;
      } else {
        discountAmount = rawDiscount;
      }
      // Clamp so discount never exceeds discountableSubTotal
      discountAmount = Math.min(discountAmount, discountableSubTotal);
    }
    const discountedSubTotal = subTotal - discountAmount;

    // Calculate VAT Amount (calculated on base subtotal, NOT discounted)
    const vatPercentage = parseFloat(formData.vatPercentage || 0);
    const vatAmount =
      vatPercentage === 0 ? 0 : (subTotal * vatPercentage) / 100;

    // Calculate Total including VAT
    let total = discountedSubTotal + vatAmount;

    // Calculate InsuranceTotal including insurance
    let InsuranceTotal = total;
    const insuranceValue = parseFloat(formData.insurance || 0);
    if (insuranceValue !== 0) {
      InsuranceTotal += insuranceValue;
    }

    // Format total to display only two decimal points
    const formattedTotal = InsuranceTotal.toFixed(2);

    // Discount metadata
    const discountData = discountAmount > 0
      ? {
          type: discountType,
          value: rawDiscount,
          amount: parseFloat(discountAmount.toFixed(2)),
          servicesSubtotalBeforeDiscount: discountableSubTotal,
        }
      : null;

    // Update state
    setTotal(formattedTotal);
    setFormData((prevData) => ({
      ...prevData,
      subTotal: subTotal.toFixed(2), // Update subTotal
      vatAmount: vatAmount.toFixed(2), // Update vatAmount
      total: formattedTotal, // Update total
      discount: discountData,
    }));
  }, [formData.services, formData.vatPercentage, formData.insurance, discountType, discountValue]);
  // console.log(formData)

const handleInputChange = (e) => {
  const { name, value } = e.target;

  if (name === "vatPercentage") {
    if (value === "" || parseFloat(value) >= 0) {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value === "" ? "" : Number(value),
      }));

      // clear error
      setValidationErrors((prev) => ({
        ...prev,
        vatPercentage: false,
      }));
    } else {
      // negative value → error
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));

      setValidationErrors((prev) => ({
        ...prev,
        vatPercentage: true,
      }));
    }
  } else if (name === "quoteCreatedDate") {
    setFormData((prevData) => ({
      ...prevData,
      [name]: new Date(value).toISOString(),
    }));
  } else {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // clear validation error when user types
    setValidationErrors((prev) => ({
      ...prev,
      [name]: false,
    }));
  }
};


  const handlePcsOfPkgInput = (index, field, e) => {
    const { value } = e.target;
    const validatedValue = validatePositiveNumber(value);

    setFormData((prevData) => {
      const newData = { ...prevData };
      const pcsPackage = [...newData.pcsPackage];

      if (pcsPackage[index]) {
        if (field === "quantity") {
          pcsPackage[index][field] = validatedValue;
        } else {
          pcsPackage[index][field].value = validatedValue;
        }
      }

      newData.pcsPackage = pcsPackage;
      return newData;
    });
      // CLEAR ERROR when user types
  setValidationErrors(prev => ({
    ...prev,
    [`pcsPackage_${index}_${field}`]: false
  }));
  };


  const handleUnitChange = (index, field, e) => {
    const { value } = e.target;

    setFormData((prevData) => {
      const newData = { ...prevData };
      const pcsPackage = [...newData.pcsPackage];

      if (pcsPackage[index]) {
        if (field === 'weight') {
          // Update only the weight unit
          pcsPackage[index].weight.unit = value;
        } else {
          // Update length, width, and height units together
          pcsPackage[index].length.unit = value;
          pcsPackage[index].width.unit = value;
          pcsPackage[index].height.unit = value;
        }
      }

      newData.pcsPackage = pcsPackage;
      return newData;
    });
  };


  useEffect(() => {
    const total = formData.pcsPackage.reduce((acc, pcs) => {
      const weightValue =
        parseFloat(pcs.quantity || 1) * parseFloat(pcs.weight.value || 0);
      return acc + weightValue;
    }, 0);

    setTotalWeight(total); // Update totalWeight state with numeric value
    setFormData((prevData) => ({
      ...prevData,
      totalWeight: total, // Set totalWeight field in formData with numeric value
    }));
  }, [formData.pcsPackage, totalWeight]);

  const handleRemovePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: prevData.pcsPackage.slice(0, -1), // Remove the last added package
    }));
  };

  const handleAddMorePcsOfpackage = () => {
    setFormData((prevData) => ({
      ...prevData,
      pcsPackage: [
        ...prevData.pcsPackage,
        {
          quantity: "", // Initialize quantity for each new item
          weight: { value: "", unit: "Kg" },
          length: { value: "", unit: "cm" },
          width: { value: "", unit: "cm" },
          height: { value: "", unit: "cm" },
        },
      ],
    }));
  };

  const handleServiceInputChange = (index, field, e) => {
    const { value } = e.target;

    setFormData((prevData) => {
      const updatedServices = [...prevData.services];
      updatedServices[index][field] = value;

      return {
        ...prevData,
        services: updatedServices,
      };
    });
  };
  // console.log(formData)
  const validatePositiveNumber = (value) => {
    // Remove any non-numeric characters except decimal point
    const sanitizedValue = value.replace(/[^0-9.]/g, "");

    // Ensure only one decimal point
    const parts = sanitizedValue.split(".");
    if (parts.length > 2) {
      parts.pop();
    }

    // Join back the parts
    let finalValue = parts.join(".");

    // Convert to number and check if it's positive and not zero
    const numValue = parseFloat(finalValue);
    if (numValue <= 0 || isNaN(numValue)) {
      finalValue = "";
    }

    return finalValue;
  };
  const updateAllUnits = (unit) => {
    setFormData((prevData) => {
      const newData = { ...prevData };
      newData.pcsPackage = newData.pcsPackage.map((pkg) => ({
        ...pkg,
        length: { ...pkg.length, unit },
        width: { ...pkg.width, unit },
        height: { ...pkg.height, unit },
      }));
      return newData;
    });
  };

  // Add functions for tempAdminEstimate compatibility
  const areMandatoryFieldsFilled = () => {
    const requiredFields = [
      "quoteNumber",
      "name",
      "loadAddress",
      "loadCountry",
      "loadCity",
      "loadPostalCode",
      "unloadAddress",
      "unloadCountry",
      "unloadCity",
      "unloadPostalCode",
      "description",
      "address"
    ];

    // Check all string fields
    for (let field of requiredFields) {
      if (!formData[field] || formData[field].trim() === "") {
        return false;
      }
    }

    // Check cargoValue and cifValue
    if (!formData.cargoValue.value || formData.cargoValue.value.trim() === "") {
      return false;
    }
    if (!formData.cifValue.value || formData.cifValue.value.trim() === "") {
      return false;
    }

    // Check packages
    if (formData.pcsPackage.length === 0) {
      return false;
    }
    for (let pkg of formData.pcsPackage) {
      if (
        !pkg.quantity ||
        !pkg.weight.value ||
        !pkg.length.value ||
        !pkg.width.value ||
        !pkg.height.value
      ) {
        return false;
      }
    }

    return true;
  };

  // For edit form, we'll assume currencies are aligned (this can be enhanced based on your needs)
  const areCurrenciesAligned = () => {
    return true; // You can implement proper currency alignment logic here if needed
  };

  const handleAddData = async (e) => {
    e.preventDefault();
    setAttemptedSubmit(true);

    let newInvalidFields = [];
    // console.log("Form submission attempted. Current formData:", formData);

    // Validate required fields
    const requiredFields = [
      "name",
      "email",
      "postalCode",
      "address",
      "loadAddress",
      "loadCountry",
      "loadCity",
      "loadPostalCode",

      "unloadAddress",
      "unloadCountry",
      "unloadCity",
      "unloadPostalCode",

      "description",
      "quoteCreatedDate"
    ];
    const errors = {};

    // if (!formData.selectedTemplate) {
    //   errors.selectedTemplate = true;
    //   toast.error("Please select a template before updating.");
    // }

    // if (!templateSelected) {
    //   toast.error("Please select a template before updating.");
    //   return;
    // }
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].toString().trim() === "") {
        errors[field] = true;
        // console.log(`Error in required field: ${field}`);
      }
    });
if (
  formData.vatPercentage === "" ||
  formData.vatPercentage === null ||
  Number(formData.vatPercentage) < 0
) {
  errors.vatPercentage = true;
  toast.error("VAT Percentage is required and must be greater than or equal to 0");
}

    // Check cargoValue and cifValue

    if (
      !formData.cargoValue.value ||
      formData.cargoValue.value.toString().trim() === ""
    ) {
      errors["cargoValue"] = true;
      // console.log("Error in cargoValue");
    }
    if (
      !formData.cifValue.value ||
      formData.cifValue.value.toString().trim() === ""
    ) {
      errors["cifValue"] = true;
      // console.log("Error in cifValue");
    }
    if (
      !formData.cargoValue.value ||
      parseFloat(formData.cargoValue.value) <= 0
    ) {
      errors["cargoValue"] = true;
      // console.log("Error in cargoValue");
    }
    if (!formData.cifValue.value || parseFloat(formData.cifValue.value) <= 0) {
      errors["cifValue"] = true;
      // console.log("Error in cifValue");
    }
if (Number(formData.vatPercentage) < 0) {
  newInvalidFields.push("vatPercentage");
  toast.error("VAT Percentage must be greater than or equal to 0");
}

    const serviceErrors = {};
    // formData.services.forEach((service, index) => {
    //   if (!service.numberOfItem || parseFloat(service.numberOfItem) <= 0) {
    //     serviceErrors[`service_${index}_numberOfItem`] = true;
    //   }
    //   if (!service.description || service.description.trim() === "") {
    //     serviceErrors[`service_${index}_description`] = true;
    //   }
    //   // if (!service.exclVAT || parseFloat(service.exclVAT) <= 0) {
    //   //   serviceErrors[`service_${index}_exclVAT`] = true;
    //   // }
    // });

    // if (Object.keys(serviceErrors).length > 0) {
    //   setValidationErrors((prev) => ({ ...prev, ...serviceErrors }));
    //   toast.error(
    //     "Please fill in all required fields in the services section."
    //   );
    //   return;
    // }
    const validatePositiveNumber = (value) => {
      // Remove any non-numeric characters except decimal point
      const sanitizedValue = value.replace(/[^0-9.]/g, "");

      // Ensure only one decimal point
      const parts = sanitizedValue.split(".");
      if (parts.length > 2) {
        parts.pop();
      }

      // Join back the parts
      let finalValue = parts.join(".");

      // Convert to number and check if it's positive and not zero
      const numValue = parseFloat(finalValue);
      if (numValue <= 0 || isNaN(numValue)) {
        finalValue = "";
      }

      return finalValue;
    };

    // Check pcsPackage
    formData.pcsPackage.forEach((pkg, index) => {
      ["quantity", "weight", "length", "width", "height"].forEach((key) => {
        if (key === "quantity") {
          if (!pkg[key] || pkg[key].toString().trim() === "") {
            errors[`pcsPackage_${index}_${key}`] = true;
            // console.log(`Error in pcsPackage: ${index}, ${key}`);
          }
        } else {
          if (!pkg[key].value || pkg[key].value.toString().trim() === "") {
            errors[`pcsPackage_${index}_${key}`] = true;
            // console.log(`Error in pcsPackage: ${index}, ${key}`);
          }
        }
      });
    });

    // Check services
    // formData.services.forEach((service, index) => {
    //   ["numberOfItem", "description"].forEach((key) => {
    //     if (!service[key] || service[key].toString().trim() === "") {
    //       errors[`service_${index}_${key}`] = true;
    //       // console.log(`Error in service: ${index}, ${key}`);
    //     }
    //   });
    // });

    if (Object.keys(errors).length > 0) {
      // console.log("Validation errors:", errors);
      setValidationErrors(errors);
      toast.error("Please fill in all required fields.");
      return;
    }

    if (!formData.quoteCreatedDate || formData.quoteCreatedDate.trim() === "") {
      errors.quoteCreatedDate = true;
      toast.error("Quote Created Date is required");
      return;
    }

    // console.log("All validations passed. Attempting to update document.");

    try {
      setLoading(true);
      const updatedFormData = { ...formData, status: "pending" };
      const userDocRef = doc(db, "quotes", id);
      await updateDoc(userDocRef, updatedFormData);
      // console.log("Document updated successfully");
      queryClient.invalidateQueries(["userQuotes", user?.uid]);
      navigate("/quoteadmin");
      toast.success("Quotes data updated successfully!");
      setAttemptedSubmit(false);
    } catch (error) {
      console.error("Error saving data:", error);
      toast.error("Error saving data. Please try again later.");
    } finally {
      setLoading(false);
    }
  };
  const downloadPDF = async () => {
    setPdfLoading(true);

    const blob = await generatePDF(formData, quotationCreatedByAdmin);
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    const fileName = `${formData.quoteNumber}.pdf`;
    link.download = fileName;
    link.click();
    setPdfLoading(false);
  };

  const formatCreationDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    return date.toISOString().split('T')[0];
  };


  // console.log(formData, "---");

  return (
    <>
      <DashboardLayout>
        {/* <div className="hidden h-full border-r sm:block ">
          <SideBar obj={obj} />
        </div> */}
        <div className="w-full">
          <Header title="Edit Form" />
          <div className="bg-white w-[95%] max-w-[1700px] mx-auto rounded-xl">
            <div id="data">
              <h2 className="p-[30px] font-bold text-xl mt-4">New Customer </h2>
              <div className=" mx-[30px] grid md:grid-cols-2 grid-cols-1 gap-3">
                <div className="flex gap-3 w-full">
                  <div className="flex flex-col gap-1 w-1/2 py-2">
                    <label className="w-full text-sm font-normal" htmlFor="quoteNumber">
                      Quote Number
                    </label>
                    <input
                      type="text"
                      placeholder=""
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      id="quoteNumber"
                      onChange={handleInputChange}
                      value={formData.quoteNumber}
                      name="quoteNumber"
                      disabled
                    />
                  </div>

                  <div className="flex flex-col gap-1 w-1/2 py-2">
                    <label className="w-full text-sm font-normal" htmlFor="creationDate">
                      Quote Created Date
                    </label>
                    <input
                      type="date"
                      className="w-full h-8 p-2 text-sm border rounded-md outline-none"
                      id="quoteCreatedDate"
                      value={formatCreationDate(formData.quoteCreatedDate)}
                      name="quoteCreatedDate"
                      onChange={handleInputChange}
                    />
                  </div>
                </div>
                <ValidityDate formData={formData} setFormData={setFormData} />

                <div className="flex flex-col gap-1 py-2">
                  <label className="w-full text-sm font-normal " htmlFor="name">
                    Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.name ? "border-red-500" : ""
                      }`}
                    onChange={handleInputChange}
                    value={formData.name}
                    name="name"
                    id="name"
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal "
                    htmlFor="companyname"
                  >
                    Email Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Email Address"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.email ? "border-red-500" : ""
                      }`}
                    onChange={handleInputChange}
                    value={formData.email}
                    name="email"
                    id="email"
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal "
                    htmlFor="addressone"
                  >
                    Postal Code <span className="text-red-500">*</span>
                  </label>
                 <input
  placeholder="Postal Code"
  className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
    validationErrors.postalCode ? "border-red-500" : ""
  }`}
  onChange={handleInputChange}
  value={formData.postalCode}
  name="postalCode"
  id="postalCode"
/>

                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal "
                    htmlFor="addresst"
                  >
                    Address <span className="text-red-500">*</span>
                  </label>
                 <input
  type="text"
  placeholder="House No"
  className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
    validationErrors.address ? "border-red-500" : ""
  }`}
  onChange={handleInputChange}
  value={formData.address}
  name="address"
  id="address"
/>

                </div>
              </div>

              <div className="mx-[30px] ">
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    Load Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Street 23, new town"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.loadAddress ? "border-red-500" : ""
                      }`}
                    id="loadAddress"
                    onChange={handleInputChange}
                    value={formData.loadAddress}
                    name="loadAddress"
                  />
                </div>
              </div>
              <div className="mx-[30px] grid md:grid-cols-4 grid-cols-1 gap-3">
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    Load Country <span className="text-red-500">*</span>
                  </label>
                  <CountrySelectInput
                    label=""
                    onChange={handleInputChange}
                    value={formData.loadCountry}
                    name="loadCountry"
                    id="loadCountry"
                    className="load-country"
                  />
                </div>
                <div className="flex flex-col gap-1 py-2 ">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    Load City <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="city name"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.loadCity ? "border-red-500" : ""
                      }`}
                    id="loadCity"
                    onChange={handleInputChange}
                    value={formData.loadCity}
                    name="loadCity"
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    Load Postal Code <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Postal Code"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.loadPostalCode ? "border-red-500" : ""
                      }`}
                    name="loadPostalCode"
                    id="loadPostalCode"
                    onChange={handleInputChange}
                    value={formData.loadPostalCode}
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    Load Company Name
                  </label>
                  <input
                    type="text"
                    placeholder="Load Company Name "
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.loadAddress_CompanyName
                      ? "border-red-500"
                      : ""
                      }`}
                    name="loadAddress_CompanyName"
                    id="loadAddress_CompanyName"
                    onChange={handleInputChange}
                    value={formData.loadAddress_CompanyName}
                  />
                </div>
              </div>

              <div className="mx-[30px] ">
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal "
                    htmlFor="country"
                  >
                    Unload Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Street 23, new town"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.unloadAddress ? "border-red-500" : ""
                      }`}
                    id="unloadAddress"
                    onChange={handleInputChange}
                    value={formData.unloadAddress}
                    name="unloadAddress"
                  />
                </div>
              </div>

              <div className="mx-[30px] grid md:grid-cols-4 grid-cols-1 gap-3">
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    Unload country <span className="text-red-500">*</span>
                  </label>
                  <CountrySelectInput
                    label=""
                    onChange={handleInputChange}
                    value={formData.unloadCountry}
                    name="unloadCountry"
                    id="unloadCountry"
                  />
                </div>
                <div className="flex flex-col gap-1 py-2 ">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    unload City <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="select city"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.unloadCity ? "border-red-500" : ""
                      }`}
                    id="unloadCity"
                    onChange={handleInputChange}
                    value={formData.unloadCity}
                    name="unloadCity"
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    unload Postal Code <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Postal Code"
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.unloadPostalCode ? "border-red-500" : ""
                      }`}
                    name="unloadPostalCode"
                    id="unloadPostalCode"
                    onChange={handleInputChange}
                    value={formData.unloadPostalCode}
                  />
                </div>
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    Unload Company Name
                  </label>
                  <input
                    type="text"
                    placeholder="unload Company Name "
                    className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.unloadAddress_CompanyName
                      ? "border-red-500"
                      : ""
                      }`}
                    name="unloadAddress_CompanyName"
                    id="unloadAddress_CompanyName"
                    onChange={handleInputChange}
                    value={formData.unloadAddress_CompanyName}
                  />
                </div>
              </div>

              <div className="mx-[30px]">
                <div className="flex flex-col gap-1 py-2 ">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="loadAddress"
                  >
                    Transportation Mode
                  </label>
                  <TransportationMode
                    formData={formData}
                    setFormData={setFormData}
                  />
                </div>
              </div>

              <div className="mx-[30px] grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="cargoValue"
                  >
                    Cargo Value <span className="text-red-500">*</span>
                  </label>
                  <div className="flex items-center">
                    <input
                      type="text"
                      className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.cargoValue ? "border-red-500" : ""
                        }`}
                      name="cargoValue"
                      id="cargoValue"
                      onChange={(e) =>
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          cargoValue: {
                            ...prevFormData.cargoValue,
                            value: validatePositiveNumber(e.target.value),
                          },
                        }))
                      }
                      value={formData.cargoValue.value || ""}
                    />
                    <Select
                      name="cargoValue-currency"
                      id="cargoValue-currency"
                      onChange={(e) => {
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          cargoValue: {
                            ...prevFormData.cargoValue,
                            currency: e,
                          },
                          cifValue: {
                            ...prevFormData.cifValue,
                            currency: e,
                          },
                        }));
                      }}
                      value={formData.cargoValue.currency || ""}
                      options={[
                        { value: "USD", label: "USD" },
                        { value: "EUR", label: "EUR" },
                        { value: "GBP", label: "GBP" },
                      ]}
                      showSearch
                    />
                  </div>
                </div>

                <div className="flex flex-col gap-1 py-2">
                  <label
                    className="w-full text-sm font-normal"
                    htmlFor="cifValue"
                  >
                    CIF Value <span className="text-red-500">*</span>
                  </label>
                  <div className="flex items-center gap-1">
                    <CIFValue formData={formData} setFormData={setFormData}  readOnly={true} />

                    <Select
                      // className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                      name="cifValue-currency"
                      id="cifValue-currency"
                      onChange={(e) =>
                        setFormData((prevFormData) => ({
                          ...prevFormData,
                          cargoValue: {
                            ...prevFormData.cargoValue,
                            currency: e,
                          },
                          cifValue: {
                            ...prevFormData.cifValue,
                            currency: e,
                          },
                        }))
                      }
                      value={formData.cifValue.currency || ""}
                      options={[
                        { value: "USD", label: "USD" },
                        { value: "EUR", label: "EUR" },
                        { value: "GBP", label: "GBP" },
                      ]}
                      showSearch
                    ></Select>
                  </div>
                </div>
              </div>

              <h2 className="mx-[30px] font-bold text-xl mt-4">Goods</h2>
              {/* <div className="mx-[30px] grid  grid-cols-1 md:grid-cols-2 gap-3">
                              <div className="flex flex-col gap-1 py-2">
                                  <label
                                      className="w-full text-sm font-normal "
                                      htmlFor="pcsOfPkg"
                                  >
                                      Pcs Package<span className="text-red">*</span>
                                  </label>
                                  <input
                                      type="number"
                                      className="w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                                      name="pcsOfPkg"
                                      id="pcsOfPkg"
                                      onChange={(e) => setPcsOfPkg(parseInt(e.target.value))}
                                      value={pcsOfPkg}
                                  />
                              </div>
                          </div> */}
              {formData.pcsPackage.map((formItem, index) => (
                <div
                  key={index}
                  className="mx-[30px] flex-wrap justify-between flex items-center gap-5"
                >
                  {/* Weight */}
                  <div className="w-full lg:w-[10%] flex flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor={`amount-${index}`}
                    >
                      Quantity <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors[`pcsPackage_${index}_quantity`]
                        ? "border-red-500"
                        : ""
                        }`}
                      id={`quantity-${index}`}
                      onChange={(e) => handlePcsOfPkgInput(index, "quantity", e)}
                      value={formData.pcsPackage[index]?.quantity || ""}
                      inputMode="decimal"
                      onKeyDown={(e) => {
                        if (e.key === "e" || e.key === "-" || e.key === "+") {
                          e.preventDefault();
                        }
                      }}
                      min="1"
                      step="1"
                    />
                  </div>
                  <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor={`weight-${index}`}
                    >
                      Weight <span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center">
                      <input
                        type="number"
                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors[`pcsPackage_${index}_weight`]
                          ? "border-red-500"
                          : ""
                          }`}
                        name={`weight-${index}`}
                        id={`weight-${index}`}
                        onChange={(e) => handlePcsOfPkgInput(index, "weight", e)}
                        value={formData.pcsPackage[index]?.weight.value || ""}
                        inputMode="decimal"
                        onKeyDown={(e) => {
                          if (e.key === "e" || e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                        min="1"
                        step="1"
                      />
                      <select
                        className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name={`weight-unit-${index}`}
                        id={`weight-unit-${index}`}
                        onChange={(e) => {
                          handleUnitChange(index, "weight", e);
                        }}
                        value={formData.pcsPackage[index]?.weight.unit || ""}
                      >
                        <option value="kg">kg</option>
                        <option value="lbs">lbs</option>
                      </select>
                    </div>
                  </div>

                  {/* Length */}
                  <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor={`length-${index}`}
                    >
                      Length <span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center">
                      <input
                        type="number"
                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors[`pcsPackage_${index}_length`]
                          ? "border-red-500"
                          : ""
                          }`}
                        name={`length-${index}`}
                        id={`length-${index}`}
                        onChange={(e) => handlePcsOfPkgInput(index, "length", e)}
                        value={formData.pcsPackage[index]?.length.value || ""}
                        inputMode="decimal"
                        onKeyDown={(e) => {
                          if (e.key === "e" || e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                        min="1"
                        step="1"
                      />
                      <select
                        className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name={`length-unit-${index}`}
                        id={`length-unit-${index}`}
                        onChange={(e) => {

                          handleUnitChange(index, "length", e)


                        }}
                        value={formData.pcsPackage[index]?.length.unit || ""}
                      >
                        <option value="cm">cm</option>
                        <option value="in">in</option>
                      </select>
                    </div>
                  </div>
                  {/* Width */}
                  <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor={`width-${index}`}
                    >
                      Width <span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center">
                      <input
                        type="number"
                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors[`pcsPackage_${index}_width`]
                          ? "border-red-500"
                          : ""
                          }`}
                        name={`width-${index}`}
                        id={`width-${index}`}
                        onChange={(e) => handlePcsOfPkgInput(index, "width", e)}
                        value={formData.pcsPackage[index]?.width.value || ""}
                        inputMode="decimal"
                        onKeyDown={(e) => {
                          if (e.key === "e" || e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                        min="1"
                        step="1"
                      />
                      <select
                        className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name={`width-unit-${index}`}
                        id={`width-unit-${index}`}
                        onChange={(e) =>
                          handleUnitChange(index, "width", e)

                        }
                        value={formData.pcsPackage[index]?.width.unit || ""}
                      >
                        <option value="cm">cm</option>
                        <option value="in">in</option>
                      </select>
                    </div>
                  </div>
                  {/* Height */}
                  <div className="flex w-full lg:w-1/5  flex-col gap-1 py-2">
                    <label
                      className="w-full text-sm font-normal"
                      htmlFor={`height-${index}`}
                    >
                      Height <span className="text-red-500">*</span>
                    </label>
                    <div className="flex items-center">
                      <input
                        type="number"
                        className={`w-full h-8 p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors[`pcsPackage_${index}_height`]
                          ? "border-red-500"
                          : ""
                          }`}
                        name={`height-${index}`}
                        id={`height-${index}`}
                        onChange={(e) => handlePcsOfPkgInput(index, "height", e)}
                        value={formData.pcsPackage[index]?.height.value || ""}
                        inputMode="decimal"
                        onKeyDown={(e) => {
                          if (e.key === "e" || e.key === "-" || e.key === "+") {
                            e.preventDefault();
                          }
                        }}
                        min="1"
                        step="1"
                      />
                      <select
                        className="ml-2 p-1 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue"
                        name={`height-unit-${index}`}
                        id={`height-unit-${index}`}
                        onChange={(e) =>
                          handleUnitChange(index, "height", e)

                        }
                        value={formData.pcsPackage[index]?.height.unit || ""}
                      >
                        <option value="cm">cm</option>
                        <option value="in">in</option>
                      </select>
                    </div>
                  </div>
                </div>
              ))}

              <div className="flex justify-between gap-5 items-center px-5 py-2">
                <div className="flex gap-1 items-center">
                  <div
                    className="mx-[20px] mt- "
                    onClick={handleAddMorePcsOfpackage}
                  >
                    <FaPlus className="text-[20px] text-[#03336E] " />
                  </div>

                  <div className="mx-[5px]  " onClick={handleRemovePcsOfpackage}>
                    <FaMinus className="text-[20px] text-[#03336E] " />
                  </div>
                </div>

                <div className="px-5 flex  items-center gap-5">
                  <p className="text-[14px]"> Total Weight:</p>
                  <p className="text-[14px] font-extrabold">
                    {formData.totalWeight ? formData.totalWeight : "00"}
                  </p>
                </div>
              </div>

              <div className="md:px-[30px] flex flex-col gap-1 py-2 w-full">
                <label className="w-full text-sm font-normal " htmlFor="country">
                  Description<span className="text-[red] ">*</span>
                </label>
        <textarea
  placeholder="Description"
  className={`w-full h-[150px] p-2 text-sm border rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${
    validationErrors.description ? "border-red-500" : ""
  }`}
  name="description"
  id="description"
  onChange={handleInputChange}
  value={formData.description}
  maxLength={1000}
/>

              </div>

              <ServiceTemp
                formData={formData}
                setFormData={setFormData}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
                templateSelected={templateSelected}
                setTemplateSelected={setTemplateSelected}
                attemptedSubmit={attemptedSubmit}
                isPopupOpen={isPopupOpen}
                setIsPopupOpen={setIsPopupOpen}
                areMandatoryFieldsFilled={areMandatoryFieldsFilled}
                areCurrenciesAligned={areCurrenciesAligned}
              />

              <div className="mx-[30px] flex flex-col lg:flex-row gap-2 ">
                <div className="w-full lg:w-[60%] bg-[#FBFCFF] p-4 rounded-lg  border border-cus-blue ">
                  <div className="flex items-center w-full lg:w-1/2 gap-1 py-2">
                    <label className="w-full text-base font-medium">
                      VAT Percentage :<span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      className={`w-full p-2 text-sm border-2 rounded-md outline-none active:border-cus-blue focus:border-cus-blue ${validationErrors.vatPercentage ? "border-red-500" : ""
                        }`}
                      name="vatPercentage"
                      id="vatPercentage"
                      onChange={handleInputChange}
                      onKeyDown={(e) => {
                        if (e.key === "e" || e.key === "-" || e.key === "+") {
                          e.preventDefault();
                        }
                      }}
                      value={formData.vatPercentage}
                      min="0"
                      step="1"
                      required
                    />
                  </div>
                  {validationErrors.vatPercentage && (
                    <p className="text-red-500 text-sm">
                      VAT Percentage must be positive number.
                    </p>
                  )}
                  {/* <InsuranceCheckbox
                    formData={formData}
                    setFormData={setFormData}
                  /> */}
                </div>

                <div className="w-full lg:w-[40%] bg-[#FBFCFF] p-4 border rounded-lg border-cus-blue">
                  <div className="flex justify-between">
                    <div>
                      <p className="text-[14px]">Sub Total</p>
                    </div>
                    <div className="">
                      <p className="text-[14px] font-extrabold">
                        {AmountFormat(formData.subTotal, formData.currency)}
                      </p>
                    </div>
                  </div>

                  <DiscountInput
                    discountType={discountType}
                    discountValue={discountValue}
                    onDiscountTypeChange={setDiscountType}
                    onDiscountValueChange={setDiscountValue}
                    currency={formData.currency}
                    discountAmount={formData.discount?.amount || 0}
                  />

                  {formData.discount && formData.discount.amount > 0 && (
                    <div className="flex justify-between mt-1 text-orange-600">
                      <div>
                        <p className="text-[14px] font-medium">
                          Discount ({formData.discount.type === 'percentage' ? `${formData.discount.value}%` : 'Fixed'})
                        </p>
                      </div>
                      <div>
                        <p className="text-[14px] font-extrabold">
                          - {AmountFormat(formData.discount.amount, formData.currency)}
                        </p>
                      </div>
                    </div>
                  )}

                  <div className="flex justify-between mt-1 ">
                    <div>
                      <p className="text-[14px]">Total VAT</p>
                    </div>
                    <div className="">
                      <p className="text-[14px] font-extrabold ">
                        {AmountFormat(formData.vatAmount, formData.currency)}
                      </p>
                    </div>
                  </div>

                  <div className="flex justify-between mt-4 border-t border-cus-blue ">
                    <div className="mt-2">
                      <p className="text-[14px]">Total</p>
                    </div>
                    <div className="mt-2">
                      <p className="text-[14px] font-extrabold ">
                        {AmountFormat(formData.total, formData.currency)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mx-[30px] flex flex-col gap-3 sm:flex-row justify-between py-6">
              <CustomButton
                label="Update Change"
                onClick={handleAddData}
                loading={loading}
              />

              <PDFDownloadButton onClick={downloadPDF} loading={pdfLoading} />
            </div>
          </div>
        </div>
      </DashboardLayout>
    </>
  );
};

export default EditQuotesForm;